export const isTma = !!(window as typeof window & { Telegram?: typeof Telegram })?.Telegram?.WebApp;
export const WebApp = isTma ? Telegram.WebApp : undefined;
export const WebView = isTma ? Telegram.WebView : undefined;
